import { useMemo } from 'react';
import type { Asset } from '@/types/GraphqlSchema';
import type { Metric } from '../types';

const BREAK_EVEN_DEFAULT_MESSAGE =
  'N/A - breakevens are displayed for values between US$0/bbl and US$200/bbl';

export const useFinancialConsiderationsMetrics = (
  asset: Asset | null,
): { metrics: Metric[]; projectKpiMetrics: Metric[] } => {
  const metrics = useMemo(() => {
    if (!asset) {
      return [];
    }

    return [
      {
        label: 'Valuation (NPV10)',
        unit: '(US$MM)',
        value: asset.formattedNpv ?? null,
      },
      {
        label: 'Remaining Capex + Abex',
        unit: '(US$MM)',
        value: asset.formattedRemainingCapex ?? null,
      },
      {
        label: 'Fiscal Regime',
        value: asset.fiscalRegime ?? null,
      },
    ];
  }, [asset]);

  const projectKpiMetrics = useMemo(() => {
    if (!asset) {
      return [];
    }

    const label = 'Breakeven Oil Price';
    const unit = asset.breakevenOil === BREAK_EVEN_DEFAULT_MESSAGE ? '' : '($/bbl)';

    return [
      {
        label,
        unit,
        value: asset.breakevenOil ?? null,
      },
    ];
  }, [asset]);

  return { metrics, projectKpiMetrics };
};
